var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-tab"},[_c('h2',[_vm._v("绑定手机号")]),_vm._v(" "),_c('Password',{attrs:{"login-type":'binding'},on:{"success":_vm.success}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }